import React, { useEffect, useState } from "react";
import { BrowserRouter } from "react-router-dom";
import AdminRoutes from "./AdminRoutes";
import UserRoutes from "./UserRoutes";
import PublicRoutes from "./PublicRoutes";
import UserLayout from "../Components/UserLayout";
import { useUserContext } from "../Contexts/user";
import AdminLayout from "../Components/AdminLayout";

const AppRoutes = () => {
  const { userData, setUserData } = useUserContext();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    const token = localStorage.getItem("token");
    const user = localStorage.getItem("user");
    if (token && user) {
      setUserData(JSON.parse(user));
    }
    setLoading(false);
  }, [setUserData]);

  if (loading) {
    return null;
  }

  let routesComponent;

  switch (userData?.role) {
    case "admin":
    case "merchant":
    case "ap":
    case "dp":
      routesComponent = (
        <AdminLayout>
          <AdminRoutes />
        </AdminLayout>
      );
      break;
    case "user":
    case "vendor":
      routesComponent = (
        <UserLayout>
          <UserRoutes />
        </UserLayout>
      );
      break;

    default:
      routesComponent = <PublicRoutes />;
      break;
  }

  return <BrowserRouter>{routesComponent}</BrowserRouter>;
};

export default AppRoutes;
